/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-07-29 20:41:57
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1/tenant`;
const api = {
  // 列表
  getList: params =>

  /*
   * return request({
   *   url: "/lyh/api/v1/system/tenant/page",
   *   method: "get",
   *   params
   * });
   */
    request({
      url: `${requestUrl}/page`,
      method: "get",
      params
    }),
  // 弹窗-客户查询
  searchCustom: params => request({
    url: `${requestUrl}/platform`,
    method: "get",
    params
  }),
  // 同步客户
  ayncCustom: data => request({
    url: `${requestUrl}/platform`,
    method: "post",
    data
  }),
  // 菜单tree
  getMenuTree: params => request({
    url: "/lyh/api/v1/system/menu/tree",
    method: "get",
    params
  }),
  // 根据客户查询对应角色
  getCustomRole: params => request({
    url: `/lyh/api/v1/system/tenant/${params.id}/role-id`,
    method: "get",
    params: {}
  }),
  // 根据客户角色查询对应菜单
  getCustomRoleMenu: params => request({
    url: `/lyh/api/v1/system/menu/tree/roleIds`,
    method: "get",
    params
  }),
  // 保存客户菜单信息
  saveCustomRole: data => request({
    url: "/lyh/api/v1/system/menu/assignment",
    method: "post",
    data
  })
};

export default api;
